import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { FetchResponse } from '../dd_panel_patient_profiles/types.ts'
import { AddMeasurementData } from './types.ts'

const getList = async <T>(
  params: string | undefined
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<T>(
      `/api/dd_panel_body_measurements/${params}`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.detail
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const addMeasurement = async <T>(
  data: AddMeasurementData
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post<T>(
      '/api/dd_panel_body_measurements/',
      data
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.detail
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const removeMeasurement = async <T>(
  measurementId: number
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.delete<T>(
      `/api/dd_panel_body_measurements/${measurementId}/`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.detail
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const editMeasurement = async <T>(
  measurementId: number,
  data: AddMeasurementData
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  const response = await httpClient.put<T>(
    `/api/dd_panel_body_measurements/${measurementId}/`,
    data
  )
  fetchResponse.data = response.data
  fetchResponse.status = response.status

  return fetchResponse
}

export const bodyMeasurementsApi = {
  getList,
  addMeasurement,
  removeMeasurement,
  editMeasurement
}
